<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="true" color="#4e97b2"></loading>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <BreadcrumbsHelper :breadcrumbs="this.Breadcrumbs" />
        </div>
      </div>
    </div>
    <div class="container text-left">
      <b-card>
        <div class="row">
          <div class="col-lg-6">
            <h1 style="display: inline; margin-right: 15px">Locations</h1>
            <b-button class="btn btn-white mb-1 btn-sm" v-if="!filtersShown" v-on:click="filtersShown = !filtersShown"
              ><font-awesome-icon icon="chevron-down" /> Show Filters</b-button
            >
            <b-button class="btn btn-white mb-1 btn-sm" v-if="filtersShown" v-on:click="filtersShown = !filtersShown"
              ><font-awesome-icon icon="chevron-up" /> Hide Filters</b-button
            >
          </div>
          <div class="col-lg-6 text-right">
            <router-link class="radius btn btn-secondary mr-2" :to="{ name: 'locations create' }">Create Location</router-link>
            <b-button @click="downloadCSV()" :disabled="downloading" class="btn btn-white"><font-awesome-icon icon="download" /> Download CSV</b-button>
          </div>
        </div>
        <div class="row justify-content-md-start mt-3" v-show="filtersShown">
          <div class="col-lg-5">
            <div>
              <b-input-group prepend="Location Name">
                <b-form-input v-model="filter" />
              </b-input-group>

              <b-input-group prepend="City">
                <b-form-input v-model="city" />
              </b-input-group>

              <b-input-group prepend="County">
                <b-form-input v-model="county" />
              </b-input-group>
            </div>
          </div>
          <div class="col-lg-5">
            <div>
              <b-form-checkbox name="unclaimed" v-model="unclaimed">Unclaimed Locations </b-form-checkbox>
              <b-input-group class="input-long-text" prepend="Last Updated Greater Than">
                <v-date-picker v-model="lastUpdated" :max-date="new Date()" />
              </b-input-group>
              <b-input-group prepend="Category / Type">
                <b-select v-model="category" @input="val => setType(val)">
                  <option value="accommodation">Accommodation</option>
                  <optgroup label="Type">
                    <option value="BedAndBreakfast">Bed &amp; Breakfast</option>
                    <option value="Campground">Campground</option>
                    <option value="HotelOrMotel">Hotel or Motel</option>
                    <option value="SportsmanLodgeOrCabin">Sportsman Lodge or Cabin</option>
                    <option value="VacationRental">Vacation Rental</option>
                  </optgroup>
                  <option value="attraction">Attraction</option>
                  <optgroup label="Type">
                    <option value="AmusementPark">Amusement Park</option>
                    <option value="BotanicalGardens">Botanical Gardens</option>
                    <option value="GolfCourse">Golf Course</option>
                    <option value="HistoricSite">Historic Site</option>
                    <option value="IndoorRecreationSite">Indoor Recreation Site</option>
                    <option value="IndustryManufacturing">Industry &amp; Manufacturing</option>
                    <option value="Museum">Museum</option>
                    <option value="NationalPark">National Park</option>
                    <option value="OtherPark">Other Park</option>
                    <option value="OutdoorRecreationSite">Outdoor Recreation Site</option>
                    <option value="ScienceCenter">Science Center</option>
                    <option value="SportsFacility">Sports Facility</option>
                    <option value="StatePark">State Park</option>
                    <option value="ZoologicalPark">Zoological Park</option>
                  </optgroup>
                  <option value="food">Food & Beverage Service</option>
                  <optgroup label="Type">
                    <option value="Bakery">Bakery</option>
                    <option value="BarLoungeNightclubOrTavern">Bar, Lounge, Nightclub or Tavern</option>
                    <option value="BreweryOrDistillery">Brewery or Distillery</option>
                    <option value="CoffeeShopOrTeaRoom">Coffee Shop or Tea Room</option>
                    <option value="DelicatessenLunchCounterOrSodaFountain">Delicatessen, Lunch Counter or Soda Fountain</option>
                    <option value="IceCreamOrDessertShop">Ice Cream or Dessert Shop</option>
                    <option value="FoodTruck">Food Truck</option>
                    <option value="Restaurant">Restaurant</option>
                  </optgroup>
                  <option value="informationSource">Information Source</option>
                  <optgroup label="Type">
                    <option value="DMO">DMO</option>
                    <option value="Organization">Organization</option>
                    <option value="VisitorCenter">Visitor Center</option>
                  </optgroup>
                  <option value="retail">Retail</option>
                  <optgroup label="Type">
                    <option value="AntiquesAndCollectibles">Antiques &amp; Collectibles</option>
                    <option value="ArtGallery">Art Gallery</option>
                    <option value="Bookstore">Bookstore</option>
                    <option value="Boutique">Boutique</option>
                    <option value="HomeAndGarden">Home &amp; Garden</option>
                    <option value="Outdoor">Outdoor</option>
                    <option value="Secondhand">Secondhand</option>
                    <option value="SpecialtyFoodAndBeverage">Specialty Food & Beverage</option>
                  </optgroup>
                  <option value="service">Service</option>
                  <optgroup label="Type">
                    <option value="BoatCharter">Boat Charter</option>
                    <option value="GuidesToursOrRides">Guides, Tours or Rides</option>
                    <option value="OutfitterOrEquipmentRental">Outfitter or Equipment Rental</option>
                    <option value="Spa">Spa</option>
                  </optgroup>
                  <option value="shoppingDestination">Shopping Destination</option>
                  <optgroup label="Type">
                    <option value="FarmersMarket">Farmers Market</option>
                    <option value="FleaMarket">Flea Market</option>
                    <option value="OutletMall">Outlet Mall</option>
                    <option value="ShoppingCenter">Shopping Center</option>
                    <option value="ShoppingDistrict">Shopping District</option>
                    <option value="ShoppingMall">Shopping Mall</option>
                  </optgroup>
                  <option value="venue">Venue</option>
                  <optgroup label="Type">
                    <option value="Amphitheater">Amphitheater</option>
                    <option value="Arena">Arena</option>
                    <option value="Cinema">Cinema</option>
                    <option value="ConcertHall">Concert Hall</option>
                    <option value="ConferenceCenter">Conference Center</option>
                    <option value="ExhibitionHall">Exhibition Hall</option>
                    <option value="FairGrounds">Fair Grounds</option>
                    <option value="MusicHall">Music Hall</option>
                    <option value="Racetrack">Racetrack</option>
                    <option value="Stadium">Stadium</option>
                    <option value="Theater">Theater</option>
                  </optgroup>
                </b-select>
              </b-input-group>

              <b-input-group>
                <b-button @click="search()">Search</b-button>
                <b-button @click="resetSearch()" class="ml-3 btn-white">Reset</b-button>
              </b-input-group>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <div class="container text-left">
      <div class="row justify-content-md-center">
        <div class="col-lg-12 mt-2">
          <b-card>
            <div v-if="sortField" class="text-center mb-2 sort-wrapper">
              <span>
                Sorting By:
                <b>{{ sortField }}</b
                >, Sort Direction:
                <b>{{ $store.state.locations.sort.direction === 'ASC' ? 'Ascending' : 'Descending' }}</b>
              </span>
            </div>
            <div class="table-responsive">
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th @click="sort('name')">Name <font-awesome-icon icon="sort" /></th>
                    <th @click="sort('address')">Address <font-awesome-icon icon="sort" /></th>
                    <th>Category</th>
                    <th @click="sort('type')">Type <font-awesome-icon icon="sort" /></th>
                    <th @click="sort('publish')">Publish <font-awesome-icon icon="sort" /></th>
                    <th>Edit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="location in $store.state.locations.list" :key="location._id">
                    <td>
                      <router-link :to="{ name: 'locations detail', params: { locationId: location._id } }" class="">
                        <template v-if="location.name.length <= 50">
                          {{ location.name }}
                        </template>
                        <template v-else>
                          {{ location.name.substring(0, 50) + '...' }}
                        </template>
                      </router-link>
                    </td>
                    <td>{{ location.address }}</td>
                    <td>{{ location.category }}</td>
                    <td>{{ location._type }}</td>
                    <td class="publish">
                      <b-select v-model="location.publish" @change="setPublishStatus(location, $event)" size="sm">
                        <option value="None">None</option>
                        <option value="Limited">Limited</option>
                        <option value="Everywhere">Everywhere</option>
                        <option value="Everywhere + Featured">Everywhere + Featured</option>
                      </b-select>
                    </td>
                    <td><router-link :to="{ name: 'locations edit', params: { locationId: location._id } }" class="btn btn-secondary">Edit</router-link></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="pagination justify-content-end mt-5">
              <div class="total-count">Total Records: {{ $store.state.locations.fullCount.toLocaleString() }}</div>
              <b-pagination
                v-if="$store.state.locations.fullCount > 0"
                :value="$store.state.locations.page.page"
                :total-rows="$store.state.locations.fullCount"
                :per-page="$store.state.locations.page.pageSize"
                :hide-ellipsis="true"
                @change="changePage"
              />
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import BreadcrumbsHelper from '../../common/BreadcrumbsHelper.vue';

export default {
  components: {
    Loading,
    BreadcrumbsHelper,
  },
  data() {
    return {
      isLoading: false,
      filtersShown: true,
      downloading: false,
      sortField: '',
      sortDict: {
        name: 'Name',
        address: 'Address',
        type: 'Location Type',
        publish: 'Publish',
      },
      filter: '',
      city: '',
      county: '',
      unclaimed: false,
      lastUpdated: null,
      category: '',
      type: '',
      Breadcrumbs: [
        {
          text: 'Dashboard',
          active: false,
          href: '/admin',
        },
        {
          text: 'Partners',
          active: true,
        },
        {
          text: 'Locations',
          active: true,
        },
      ],
    };
  },
  async created() {
    try {
      this.isLoading = true;
      await this.$store.dispatch('locations/getLocations');
      this.sortField = this.sortDict[this.$store.state.locations.sort.field];
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async setPublishStatus(location, e) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_LOCATIONS_ROOT}/updatePublishStatus/${location._id}/${e}`);
        this.$bvToast.toast(`${response.data}`, {
          title: 'Success',
          autoHideDelay: 5000,
          appendToast: true,
        });
      } catch (err) {
        this.$bvToast.toast('Location Publish Not Updated', {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
      }
    },
    async sort(field) {
      try {
        this.isLoading = true;
        await this.$store.dispatch('locations/sortLocations', field);

        this.sortField = this.sortDict[field];
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async search() {
      try {
        this.isLoading = true;
        this.$store.commit('locations/setFilter', this.filter);
        this.$store.commit('locations/setCity', this.city);
        this.$store.commit('locations/setCounty', this.county);
        this.$store.commit('locations/setUnclaimed', this.unclaimed);
        this.$store.commit('locations/setLastUpdated', this.lastUpdated);
        this.$store.commit('locations/setCategory', this.category);
        this.$store.commit('locations/setType', this.type);
        await this.$store.dispatch('locations/getLocations');
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async resetSearch() {
      try {
        this.isLoading = true;
        this.$store.dispatch('locations/resetFilter');
        this.filter = '';
        this.city = '';
        this.county = '';
        this.unclaimed = false;
        this.lastUpdated = null;
        this.category = '';
        this.type = '';
        await this.$store.dispatch('locations/getLocations');
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async changePage(page) {
      try {
        this.isLoading = true;
        await this.$store.dispatch('locations/setPage', page);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    setType(val) {
      if (
        val === 'accommodation'
        || val === 'attraction'
        || val === 'food'
        || val === 'informationSource'
        || val === 'retail'
        || val === 'service'
        || val === 'shoppingDestination'
        || val === 'venue'
      ) {
        this.category = val;
        this.type = null;
      } else {
        this.type = val;
      }
    },
    async downloadCSV() {
      const query = { ...this.$store.state.locations };
      let url = `${process.env.VUE_APP_API_LOCATIONS_ROOT}/?csv=true`;
      if (query.filter && query.filter !== '') {
        url += `&filter=${query.filter}`;
      }
      if (query.city && query.city !== '') {
        url += `&city=${query.city}`;
      }
      if (query.county && query.county !== '') {
        url += `&county=${query.county}`;
      }
      if (query.unclaimed) {
        url += '&unclaimed=true';
      }
      if (query.lastUpdated) {
        url += `&lastUpdated=${query.lastUpdated}`;
      }
      if (query.category) {
        url += `&category=${query.category}`;
      }
      if (query.type) {
        url += `&type=${query.type}`;
      }

      try {
        document.body.style.cursor = 'wait';
        this.downloading = true;
        await axios({
          method: 'get',
          url,
          responseType: 'blob',
        }).then((response) => {
          const url2 = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url2;
          link.setAttribute('download', 'locations.csv'); // or any other extension
          document.body.appendChild(link);
          link.click();
        });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.downloading = false;
        document.body.style.cursor = 'default';
      }
    },
  },
};
</script>

<style scoped>
.input-group {
  padding: 5px 0px;
  width: 100%;
}
.input-group-prepend,
.input-group-append {
  width: 150px;
}
.input-long-text >>> .input-group-prepend {
  width: 210px;
}
.input-group-text {
  width: 100%;
}
.card {
  border: none;
}
.sort-wrapper span {
  background-color: #f5ecca;
  padding: 5px 10px;
  border-radius: var(--rounded-md);
  margin-bottom: 5px;
  display: inline-block;
}
th.sort span {
  cursor: pointer;
}
.total-count {
  padding: 0px 20px 0px 0px;
  line-height: 35px;
}
.fa-sort {
  color: #ccc;
}
table thead th {
  white-space: nowrap;
}
</style>
